import { render, staticRenderFns } from "./RegisterComponent.vue?vue&type=template&id=26af4588&scoped=true&"
import script from "./RegisterComponent.vue?vue&type=script&lang=js&"
export * from "./RegisterComponent.vue?vue&type=script&lang=js&"
import style0 from "./RegisterComponent.vue?vue&type=style&index=0&id=26af4588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26af4588",
  null
  
)

export default component.exports